import React from 'react';
import s from './Item.css';
import Image from '../Utils/Image';
import Pentagon from '../Utils/Pentagon';

class Item extends React.Component {

  selectItem = () => {
    this.props.selectItem(this.props.item.id);
  }

  buildImgLink = (item, params = {}) => {
    // const gender = (item.gender === 'W') ? 'WOMEN' : 'MEN';
    const position = 'FRONT';
    const collection = 'WW1617';
    const suffix = '.png';
    const colorCode = Array.isArray(item.colors) ? item.colors[0] : item.colors;  // DEPRECATED:  should be *only* array, and not mixed array/string
    const dpr = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    const defaultParams = { h: 100, bg: 303133, auto: 'format', fm: 'png32', q: 85, dpr };
    const p = { ...defaultParams, ...params };
    const paramsQ = '?' + Object.keys(p).map(k => `${k}=${p[k]}`).join('&');
    // return 'http://blackyak.imgix.net/products/WW1617/JKF6002/JKF6002_CH_BACK.png';

    return [
      'http://blackyak.imgix.net/products',
      collection,
      item.id,
      [
        item.id,
        colorCode,
        position,
      ].join('_'),
    ].join('/')
    + suffix
    + paramsQ;
  }

  render() {
    const { item, selected } = this.props;
    const cls = s.item + (selected ? ' ' + s.selected : '');
    const img = selected ?
                  <Image src={this.buildImgLink(item, { h: 500, w: 500 })} /> :
                  <Pentagon href={this.buildImgLink(item, { h: 200, w: 200, fit: 'crop', crop: 'entropy' })} size={200} />;

    return (
      <div onClick={this.selectItem} className={cls} >
        {img}
      </div>
    );
  }
}

Item.propTypes = {
  item: React.PropTypes.object.isRequired,
  selectItem: React.PropTypes.func.isRequired,
  selected: React.PropTypes.bool.isRequired,
};

export default Item;



/** WEBPACK FOOTER **
 ** ./components/Products/Item.js
 **/